import { render, staticRenderFns } from "./UnsupportedBankPopup.vue?vue&type=template&id=185c2ffa&scoped=true&"
import script from "./UnsupportedBankPopup.vue?vue&type=script&lang=js&"
export * from "./UnsupportedBankPopup.vue?vue&type=script&lang=js&"
import style0 from "./UnsupportedBankPopup.vue?vue&type=style&index=0&id=185c2ffa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185c2ffa",
  null
  
)

export default component.exports